export function shareRemind(remindUrl='', remindText=false) {
	let path = 'https://www.remind.com/v1/share'
	path += '?url=' + remindUrl
	path += '&referrer=' + window.location.href
	path += remindText ? '&text=' + encodeURIComponent(remindText) : ''
	window.open(path, '_blank')
}
